import React, { useState, useEffect, useLayoutEffect } from 'react';
import axios from 'axios';
// @mui
import { Grid, Button, Container, Stack, Typography, Pagination } from '@mui/material';
import { styled } from '@mui/material/styles';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
// components
import WriteCommunity from '../CommunityComponents/WriteCommunity';

import ViewPost from './ViewPost';

// ----------------------------------------------------------------------

const StyledSection = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '30px',
  marginTop: 30,
}));

const DivTable = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

const DivTableBody = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

const DivTableRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '2rem',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  borderBottom: '1px solid #ddd',
});

const DivTableCell = styled('div')({
  display: 'flex',
});

const DivTableTitle = styled('h4')({
  fontWeight: 500,
  marginBottom: '10px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

const DivTableContent = styled('p')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const StyledPagination = styled(Pagination)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '40px',
  '& .Mui-selected': {
    backgroundColor: '#1a9ef8 !important',
    color: '#fff !important',
  },
  Button: {
    fontSize: '1.2rem',
    padding: '1rem',
  },
});

// ----------------------------------------------------------------------

export default function ViewPostList({ data }) {
  // const sendData = data;
  const [sendData, setSendData] = useState(data);

  const { boardId } = data;

  const [boardList, setBoardList] = useState([]);
  const [postList, setPostList] = useState(true);
  const [viewPost, setViewPost] = useState(false);
  const [contentId, setContentId] = useState('');
  const [postListTotalCount, setPostListTotalCount] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(1);

  const [write, setWrite] = useState(false);

  // ----------------------------------------------------------------------

  const [userType, setUserType] = useState('');

  // ----------------------------------------------------------------------

  // 취소 button

  const CloseViewPost = () => {
    setViewPost(false);
    setPostList(true);
  };

  const CancelWrite = () => {
    setViewPost(false);
    setWrite(false);
    setPostList(true);
  };

  // console.log('data', data)

  // ----------------------------------------------------------------------
  const [page, setPage] = React.useState(1);
  const pageChange = (event, value) => {
    setPage(value);
    const data = {
      ...sendData,
      page_number: value,
    };
    // setSendData({
    //   ...sendData,
    //   page_number: value,
    // });

    fetchData(data);
  };

  const fetchData = async (jsonData) => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SERVER_URL}/boards/list`,
        method: 'post',
        data: jsonData,
      });

      // console.log("data",response.data[0][0]);
      setTotalPageCount(Math.ceil(response.data[0][0].total_count / 5));
      const newBoardList = [];

      for (let i = 0; i < response.data[0].length; i += 1) {
        newBoardList.push({
          id: response.data[0][i].content_id,
          title: response.data[0][i].content_title,
          content: response.data[0][i].content_message.replace(/(<([^>]+)>)/gi, ''),
          userName: response.data[0][i].user_name,
          userCompanyName: response.data[0][i].company_name,
          createdAt: response.data[0][i].created_at,
        });
      }

      setBoardList(newBoardList);
    } catch (error) {
      console.log('error', error);
    }
  };

  useLayoutEffect(() => {
    fetchData(sendData);
    if (sessionStorage.getItem('login_info') !== null) {
      if (JSON.parse(sessionStorage.getItem('login_info')).user_type === 'ADMIN') {
        setUserType(JSON.parse(sessionStorage.getItem('login_info')).user_type);
      }
    }
  }, []);

  return (
    <>
      {!viewPost && !write && (
        <div style={{ padding: '60px 10%' }}>
          <DivTable sx={{ minWidth: 650, borderTop: '2px solid #333' }} aria-label="simple table">
            <DivTableBody>
              {boardList.map((row) => (
                <DivTableRow
                  key={row.id}
                  hover
                  onClick={() => {
                    if (!viewPost) {
                      setContentId(row.id);
                      setViewPost(true);
                      setPostList(false);
                    }
                  }}
                >
                  <DivTableCell component="th" scope="row">
                    {row.name}
                  </DivTableCell>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      flex: 1,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <DivTableTitle>{row.title}</DivTableTitle>
                    <DivTableContent>{row.content}</DivTableContent>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                      style={{
                        padding: '20px',
                        width: '200px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <DivTableCell>{row.userName}</DivTableCell>
                    </div>
                    <DivTableCell style={{ width: '120px', justifyContent: 'flex-end' }}>{row.createdAt}</DivTableCell>
                  </div>
                </DivTableRow>
              ))}
            </DivTableBody>
          </DivTable>
          <StyledPagination
            count={totalPageCount}
            page={page}
            onChange={pageChange}
            color="primary"
            size="large"
            shape="rounded"
            style={{}}
          />
          {(boardId === 23 || userType === 'ADMIN') && userType !== '' && !write && (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                onClick={() => {
                  setWrite(true);
                  setViewPost(false);
                }}
                style={{ padding: '1rem 4rem' }}
              >
                글쓰기
              </Button>
            </div>
          )}
        </div>
      )}
      {viewPost && <ViewPost data={contentId} closeViewPost={CloseViewPost} />}

      {write && <WriteCommunity parentFunction={CancelWrite} boardID={boardId} fetchData={fetchData} data={data} />}
    </>
  );
}
